module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av721-3155dad370c33aef483b08700af18911.jpg";